import { OnboardingModuleComponentBaseProps } from './Onboarding.model';

export class OnboardingRegistrationModel
  implements OnboardingRegistrationModelProps
{
  userData: OnboardingModuleComponentBaseProps<OnboardingRegistrationUserDataProps>;
  gmbData: OnboardingModuleComponentBaseProps<OnboardingRegistrationGmbDataProps>;
  //subscriptionData: OnboardingModuleComponentBaseProps<OnboardingRegistrationSubscriptionDataProps>;

  constructor(payload: OnboardingRegistrationModelProps) {
    payload.userData.fields.phone = (
      payload?.userData?.fields?.phone || ''
    ).replace(/\D/g, '');
    payload.gmbData.fields.phone = (
      payload?.gmbData?.fields?.phone || ''
    ).replace(/\D/g, '');

    this.userData = payload.userData;
    this.gmbData = payload.gmbData;
    //this.subscriptionData = payload.subscriptionData;
  }

  static empty() {
    return new OnboardingRegistrationModel({
      userData: {
        completed: false,
        fields: {
          name: null,
          lastName: null,
          countryName: null,
          countryCode: null,
          language: null,
          languageCode: null,
          phone: null,
          email: null,
        },
      },
      gmbData: {
        completed: false,
        fields: {
          templateId: null,
          templateDescription: null,
          businessName: null,
          phone: null,
          streetAddress: null,
          addressExtNumber: null,
          latitude: null,
          longitude: null,
          email: null,
          fullAddress: null,
          settlement: null,
          locality: null,
          state: null,
          country: null
        },
      },
      /* subscriptionData: {
        completed: false,
        fields: {
          type: null,
          cardDetails: {
            cardNumber: null,
            alias: null,
            expirationMonth: null,
            expirationYear: null,
            countryCode: null,
            zipcode: null,
          },
        },
      }, */
    });
  }
}

export interface OnboardingRegistrationModelProps {
  userData: OnboardingModuleComponentBaseProps<OnboardingRegistrationUserDataProps>;
  gmbData: OnboardingModuleComponentBaseProps<OnboardingRegistrationGmbDataProps>;
  //subscriptionData: OnboardingModuleComponentBaseProps<OnboardingRegistrationSubscriptionDataProps>;
}

export interface OnboardingRegistrationUserDataProps {
  name: string;
  lastName: string;
  countryName: string;
  countryCode: string;
  language: string;
  languageCode: string;
  phone: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  mobile_phone?: string;
  email: string;
  brand_id?: number;
  platform_login?: string;
  third_id?: string;
}

export interface OnboardingRegistrationGmbDataProps {
  businessName: string;
  templateId: string | number;
  templateDescription: string;
  phone: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  mobile_phone?: string;
  email: string;
  streetAddress: string;
  addressExtNumber: string;
  latitude: string | number;
  longitude: string | number;
  fullAddress: string;
  settlement: string;
  locality: string;
  state: string;
  country: string;
}

export interface OnboardingBusinessIdDataProps {
  businessId: number;
}

export interface OnboardingRegistrationSubscriptionDataProps {
  type: 'basic' | 'advanced';
  cardDetails: {
    cardNumber: string;
    alias: string;
    expirationMonth: string;
    expirationYear: string;
    countryCode: string;
    zipcode: string;
  };
}

export const ONBOARDING_REGISTRATION_KEY = 'onboardingRegistration';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOnboardingRegistrationLocalStorageProps
  extends OnboardingRegistrationModelProps {}
